import { types, actions } from './requests'
export const GETTIMECALENDARLIST_TYPES = {
    ...types('GETTIMECALENDARLIST'),
}
export const GETTIMECALENDARLIST_ACTIONS = {
    ...actions('GETTIMECALENDARLIST'),
}